/**
 * Single source for admin → backend base URL.
 *
 * CRA: prefix env vars with REACT_APP_
 * - REACT_APP_API_URL  Full base including /api e.g. https://laundry-yq0p.onrender.com/api
 * - REACT_APP_API_SECRET  Bearer token matching api SECRET_KEY
 */

const strip = (v) =>
  typeof v === "string" ? v.trim().replace(/\/+$/, "") : "";

/** @type {string} */
export const API_URL =
  strip(process.env.REACT_APP_API_URL) ||
  "https://laundry-yq0p.onrender.com/api";

/** Bearer for global Verifysecret middleware (override with REACT_APP_API_SECRET) */
export const API_SECRET =
  process.env.REACT_APP_API_SECRET?.trim() || "galla0712@@";
